import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import connect from 'connect-alt';

/**
 * Class representing an ad unit on the website.
 */
@connect('Advertisement')
class AdvertisementUnit extends Component {
  static propTypes = {
    AdvertisementStore: PropTypes.object.isRequired,
    className: PropTypes.string,
    adData: PropTypes.object,
    isAutoAd: PropTypes.bool,
    isLazyAd: PropTypes.bool
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  state = {
    rendered: false
  }

  componentDidMount() {
    let {
      adData = {}
    } = this.props;
    if ('serverRendered' in adData) return;
    adData.wnsz = adData.id;
    let ad = new window.Worldnow.Ad(adData);
    window.Worldnow.AdMan.start();
    ad.load();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
       adData = {},
       className: classNameProp,
       AdvertisementStore: {
         showAds = true
       },
       isAutoAd
    } = this.props;

    if (typeof(window) === 'undefined') {
      adData.serverRendered = true;
    }

    const className = classNames('AdvertisementUnit',
      classNameProp,
      { 'adhesion': adData.adhesion }
    );

    if (!showAds) {
      return null;
    }

    const AD_SIZE_MAPPING = {
      1: { width: 468, height: 60 },
      14: { width: 120, height: 600 },
      16: { width: 1, height: 1 },
      17: { width: 1, height: 1 },
      18: { width: 120, height: 240 },
      20: { width: 180, height: 150 },
      21: { width: 88, height: 31 },
      22: { width: 490, height: 25 },
      23: { width: 120, height: 240 },
      24: { width: 120, height: 15 },
      26: { width: 120, height: 60 },
      27: { width: 120, height: 60 },
      28: { width: 120, height: 60 },
      35: { width: 180, height: 150 },
      40: { width: 468, height: 60 },
      41: { width: 728, height: 90 },
      42: { width: 160, height: 600 },
      43: { width: 300, height: 250 },
      44: { width: 300, height: 75 },
      45: { width: 1, height: 1 },
      46: { width: 728, height: 90 },
      47: { width: 300, height: 150 },
      49: { width: 500, height: 300 },
      50: { width: 300, height: 175 },
      52: { width: 300, height: 250 },
      54: { width: 645, height: 300 },
      63: { width: 300, height: 600 },
      85: { width: 850, height: 30 },
      86: { width: 980, height: 30 },
      101: { width: 300, height: 150 },
      103: { width: 320, height: 250 },
      104: { width: 468, height: 60 },
      105: { width: 320, height: 50 },
      106: { width: 320, height: 50 }
    };

    if (isAutoAd && adData.id in AD_SIZE_MAPPING) {
      adData.width = AD_SIZE_MAPPING[adData.id].width;
      adData.height = AD_SIZE_MAPPING[adData.id].height;
    }

    return (
     <div className={className} id={"WNAd" + adData.id} data-adData={JSON.stringify(adData)}></div>
    );
  }

}

export default AdvertisementUnit;



// WEBPACK FOOTER //
// ./app/components/AdvertisementUnit.js